<elcia-title [title]="'invoice.creation' | translate"/>

<p-stepper [value]="currentStep()" class="block w-full pb-6">
  <p-step-list>
    <p-step [value]="1">{{ 'invoice.step.edit' | translate }}</p-step>
    <p-step [value]="2">{{ 'invoice.step.preview' | translate }}</p-step>
    <p-step [value]="3">{{ 'invoice.step.send' | translate }}</p-step>
  </p-step-list>
</p-stepper>

@switch (currentStep()) {
  @case (1) {
    <elcia-invoice-edit [fg]="fg" [minInvoiceDate]="minInvoiceDate()"/>
    <div class="flex justify-end py-8">
      <elcia-button (onClick)="goToPreview()" [icon]="'right-arrow'" [label]="'action.next' | translate"/>
    </div>
  }
  @case (2) {
    <elcia-invoice-preview [fg]="fg"/>
    <div class="flex justify-between py-8">
      <elcia-button (onClick)="goToStep(1)" [variant]="'outlined'" [icon]="'chevron-left'"
                    [label]="'action.back' | translate"/>
      <elcia-button (onClick)="goToStep(3)" [icon]="'right-arrow'" [label]="'action.next' | translate"/>
    </div>
  }
  @case (3) {
    <elcia-invoice-send #sendStep [fg]="fg"/>
    <div class="flex justify-between py-8">
      <elcia-button (onClick)="goToStep(2)" [variant]="'outlined'" [icon]="'chevron-left'"
                    [label]="'action.back' | translate"/>
      <elcia-button (onClick)="sendStep.send()" [isLoading]="sendStep.isSending()" [icon]="'send'"
                    [label]="'action.send' | translate"/>
    </div>
  }
}
